import React from 'react';
import styled from 'styled-components';

const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin: 1.5rem 0;
`;

const TagsTitle = styled.h4`
    color: ${props => props.theme.body.headers};
    font-family: 'Poppins', sans-serif;
    margin-bottom: 0.75rem;
    font-size: 0.9rem;
    font-weight: 500;
`;

const TagBadge = styled.span`
    padding: 0.4rem 0.8rem;
    background: ${props => props.theme.body.text}10;
    color: ${props => props.theme.body.text};
    border: 1px solid ${props => props.theme.body.text}20;
    border-radius: 15px;
    font-size: 0.8rem;
    font-weight: 300;
    font-family: 'Poppins', sans-serif;
    cursor: ${props => props.clickable ? 'pointer' : 'default'};
    transition: all 0.3s ease;

    &:hover {
        background: ${props => props.clickable ? props.theme.body.text + '20' : props.theme.body.text + '10'};
        transform: ${props => props.clickable ? 'translateY(-1px)' : 'none'};
    }
`;

const TagsDisplay = ({ 
    tags = [], 
    onTagClick = null,
    title = "Etiquetas"
}) => {
    if (!tags || tags.length === 0) return null;

    return (
        <div>
            <TagsTitle>{title}</TagsTitle>
            <TagsContainer>
                {tags.map((tag, index) => (
                    <TagBadge
                        key={index}
                        clickable={!!onTagClick}
                        onClick={() => onTagClick && onTagClick(tag)}
                        title={onTagClick ? `Ver más sobre: ${tag}` : tag}
                    >
                        #{tag}
                    </TagBadge>
                ))}
            </TagsContainer>
        </div>
    );
};

export default TagsDisplay;